import DebugRepository from "./DebugRepository";
import ApiRepository from "./ApiRepository";

const repositories = {
  debug: DebugRepository,
  api: ApiRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name]
};